import { UpdateTeamMemberData } from "../api";
import { TeamMemberProfileFormValuesType } from "../types/teamMembers";

export const updateTeamMemberProfileFormToRequest = (
  values: TeamMemberProfileFormValuesType,
): UpdateTeamMemberData => {
  return {
    name: values.name,
    last_name: values.last_name,
    signature_name: values.signature_name,
    preferred_reference: values.preferred_reference ?? "",
  };
};
